module.exports = __webpack_public_path__ + "img/propeller-color-icon.0b8aa13d.svg";